<ng-template #confirmationModalTemplate>
  <app-modal-header>
    <h3>{{ Title() }}</h3>
  </app-modal-header>
  <app-modal-body>
    <div class="body" [innerHTML]="Body()"></div>
  </app-modal-body>
  <app-modal-footer>
    <app-button [Disabled]="IsProcessing()" [IsNoBackground]="true" (click)="OnCancelButtonClicked.emit()">{{ RejectButtonText() }}</app-button>
    <app-button [Disabled]="IsProcessing()" (click)="OnConfirmButtonClicked.emit()">{{ ConfirmButtonText() }}</app-button>
  </app-modal-footer>
</ng-template>